import { useMemo } from "react";

export function useTeamScheduleEventItemTextSize(
  textLength: number,
  width: number
) {
  const sizes = useMemo(
    () => ({
      large: 16,
      medium: 12,
    }),
    []
  );
  const largeLimit = useMemo(() => Math.ceil(width / 14) * 1, [width]);

  return useMemo(
    () => (textLength > largeLimit ? sizes.medium : sizes.large),
    [largeLimit, sizes.large, sizes.medium, textLength]
  );
}
